import{DOC as o,DOCX as r,PDF as t}from"../../constants/file.js";var s,D=((s={})[o]="DOC",s[r]="DOCX",s[t]="PDF",s);export{D as FILE_EXTENSIONS};
//# sourceMappingURL=type.js.map
